import keycloakAxios from '@/services/axios';
import {EventFormData} from '@/types/event';

export const updateEvent = async (id: string, updateData: EventFormData) => {
  const response = await keycloakAxios.post(`/event/update/${id}`, updateData);

  if (response.status >= 300) {
    throw new Error(
      `Error updating event: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
